import JSBI from 'jsbi';

export class Fraction {
  constructor(public numerator: JSBI, public denominator: JSBI) {}
}

export const ZERO_FRACTION = new Fraction(JSBI.BigInt(0), JSBI.BigInt(1));
